const payouts = [
    0,
    0,
    0,
    1,
    1.5,
    2,
    4,
    10,
    25,
    50,
    500,
    1500,
    3000,
    4000,
    5000
];

//wrapper for leander api
//for now it uses fake calls
class APIService {

   
}

export default new APIService();